import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoForSection() {
  return <section className="py-24 bg-zinc-950 border-t border-zinc-900" data-id="element-171">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-172">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24" data-id="element-173">
          {/* Who it's for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-174">
            <h3 className="font-display text-3xl text-zinc-100 mb-8 pb-4 border-b border-zinc-800" data-id="element-175">
              BUILT FOR YOU <span className="text-teal-500" data-id="element-176">IF...</span>
            </h3>
            <ul className="space-y-6" data-id="element-177">
              {['Laid-off Software Engineers, PMs, and SaaS leads who need income now.', "Tech professionals tired of the 'apply and pray' cycle.", "Experts who want to stop being a 'cog' and start being a consultant.", "Anyone with a mortgage to pay who can't wait 6 months for a 'corporate hiring cycle.'"].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-178">
                  <CheckCircle2 className="w-6 h-6 text-teal-500 shrink-0 mt-0.5" data-id="element-179" />
                  <span className="text-zinc-300 text-lg" data-id="element-180">{text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who it's not for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-181">
            <h3 className="font-display text-3xl text-zinc-100 mb-8 pb-4 border-b border-zinc-800" data-id="element-182">
              SKIP THIS <span className="text-red-500" data-id="element-183">IF...</span>
            </h3>
            <ul className="space-y-6" data-id="element-184">
              {['Entry-level juniors with no proof of work.', "Those looking for a 'passive income' magic pill.", 'Anyone afraid to send a direct message or have a professional conversation.'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-185">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-186" />
                  <span className="text-zinc-400 text-lg" data-id="element-187">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}